import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetNewsResponseModel } from "@/features/news/services/get-news-model";

export class GetNewsApi {
  /**
   * お知らせ一覧取得API
   */
  public getNews = async (): Promise<GetNewsResponseModel[]> => {
    const path = `/api/noticeinfo`;
    const res = await ApiClient.instance.get<GetNewsResponseModel[]>({
      path: path,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
